/**
 * ProtectedRoute Component
 * Auth guard that redirects unauthenticated users to login
 */

import { Navigate, useLocation } from 'react-router-dom';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

/**
 * Wraps routes that require authentication.
 * Redirects to login page if user is not authenticated.
 * Preserves the original location for redirect after login.
 *
 * Note: User data refresh is handled once at app level by AuthInitializer,
 * not per-route, to avoid redundant API calls on every navigation.
 */
export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const location = useLocation();

  const accessToken = localStorage.getItem('accessToken');
  const isAuthenticated = !!accessToken;

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return <>{children}</>;
}
